import { z } from "zod";
import { BaseFirestoreSchema } from "./firestore.schema";
import { AddressSchema } from "./address.schema";
import {
  PublicTeamMemberSchema,
  TeamMemberSchema,
  TeamMemberWContactSchema,
} from "./teamMember.schema";
import { DateTypeSchema } from "./core.schema";

// Schemas

export const TimeSchema = z.object({ hours: z.number(), minutes: z.number() });

export const TeamSchema = BaseFirestoreSchema.extend({
  name: z.string(),
  address: AddressSchema.optional(),
  adminUsers: z.string().array(),
  editUsers: z.string().array(),
  viewUsers: z.string().array(),
  submitUsers: z.string().array(),
  noneUsers: z.string().array().optional(),
  allUsers: z.string().array(),
  teamMembers: TeamMemberSchema.array(),
  defaultTemplateId: z.string().optional(),
  defaultLetterHeadId: z.string().optional(),
  defaultStartTime: TimeSchema.optional(),
  defaultEndTime: TimeSchema.optional(),
  publishedAt: DateTypeSchema.optional(),
});

export const TeamWContactSchema = TeamSchema.omit({ teamMembers: true }).extend(
  { teamMembers: TeamMemberWContactSchema.array() }
);

export const PublicTeamSchema = TeamSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  name: true,
  address: true,
  teamMembers: true,
  defaultTemplateId: true,
  defaultLetterHeadId: true,
  publishedAt: true,
}).extend({
  teamMembers: PublicTeamMemberSchema.array(),
});

// DTOs

export const CreateTeamDtoSchema = TeamSchema.partial().and(
  TeamSchema.required().pick({
    name: true,
  })
);

export const PutTeamDtoSchema = CreateTeamDtoSchema;

export const PatchTeamDtoSchema = TeamSchema.partial();
